var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"telegram-bind-page"},[_c('transition',{attrs:{"name":"ld-hide-fade"}},[(!_vm.userInfo.telegram || !_vm.userInfo.telegram.id)?_c('telegram-bind'):_c('telegram-bind-success')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-464cee40","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/_mobile/owner/_user/bind/telegram.vue
// module id = null
// module chunks = 